import { CalculatedOneReach } from 'api/services/mediaPlanning/types';

const applyCellTextStyle = (row: CalculatedOneReach['results'][number]) => ({
  fontWeight: row.isSelected ? 'bold' : 'normal',
});

export default applyCellTextStyle;
